import React from "react";
import { Button } from "@/components/ui/button";
import { Camera, Image as ImageIcon, Smartphone } from "lucide-react";
import { Label } from "@/components/ui/label";

interface ImageUploadOptionsProps {
  onGallerySelect: () => void;
  onCameraSelect: () => void;
  onEitherSelect: () => void;
  disabled?: boolean;
}

const ImageUploadOptions = ({ 
  onGallerySelect, 
  onCameraSelect, 
  onEitherSelect,
  disabled = false 
}: ImageUploadOptionsProps) => {
  return (
    <div className="space-y-3">
      <Label>Choose Image Source</Label>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <Button
          type="button"
          variant="outline"
          onClick={onGallerySelect}
          disabled={disabled}
          className="flex items-center gap-2 h-auto py-3"
        >
          <ImageIcon className="h-4 w-4" />
          <span className="text-xs sm:text-sm">Photo Library</span>
        </Button>
        
        <Button
          type="button"
          variant="outline"
          onClick={onCameraSelect}
          disabled={disabled}
          className="flex items-center gap-2 h-auto py-3"
        >
          <Camera className="h-4 w-4" />
          <span className="text-xs sm:text-sm">Take Photo</span>
        </Button>
        
        <Button
          type="button"
          variant="outline"
          onClick={onEitherSelect}
          disabled={disabled}
          className="flex items-center gap-2 h-auto py-3"
        >
          <Smartphone className="h-4 w-4" />
          <span className="text-xs sm:text-sm">Choose Method</span>
        </Button>
      </div>
    </div>
  );
};

export default ImageUploadOptions;